import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faLightbulb, faExclamationTriangle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';

export type InfoCardType = 'info' | 'warning' | 'success' | 'tip';

type Config = {
  bg: string;
  border: string;
  icon: IconDefinition;
  iconColor: string;
  titleColor: string;
  textColor: string;
};

const CONFIGS: Record<InfoCardType, Config> = {
  info: { bg: 'bg-sky-50 dark:bg-sky-900/20', border: 'border-sky-200 dark:border-sky-800', icon: faLightbulb, iconColor: 'text-sky-500', titleColor: 'text-sky-800 dark:text-sky-300', textColor: 'text-sky-700 dark:text-sky-400' },
  warning: { bg: 'bg-amber-50 dark:bg-amber-900/20', border: 'border-amber-200 dark:border-amber-800', icon: faExclamationTriangle, iconColor: 'text-amber-500', titleColor: 'text-amber-800 dark:text-amber-300', textColor: 'text-amber-700 dark:text-amber-400' },
  success: { bg: 'bg-emerald-50 dark:bg-emerald-900/20', border: 'border-emerald-200 dark:border-emerald-800', icon: faCheckCircle, iconColor: 'text-emerald-500', titleColor: 'text-emerald-800 dark:text-emerald-300', textColor: 'text-emerald-700 dark:text-emerald-400' },
  tip: { bg: 'bg-violet-50 dark:bg-violet-900/20', border: 'border-violet-200 dark:border-violet-800', icon: faLightbulb, iconColor: 'text-violet-500', titleColor: 'text-violet-800 dark:text-violet-300', textColor: 'text-violet-700 dark:text-violet-400' },
};

/** กล่องข้อความเน้น (info / warning / success / tip) */
const InfoCard: React.FC<{ type: InfoCardType; title: string; children: React.ReactNode }> = ({ type, title, children }) => {
  const c = CONFIGS[type];
  return (
    <div className={`${c.bg} border ${c.border} rounded-xl p-4 flex items-start gap-3 mb-5`}>
      <FontAwesomeIcon icon={c.icon} className={`${c.iconColor} text-lg mt-0.5 shrink-0`} />
      <div>
        <strong className={`${c.titleColor} text-sm`}>{title}</strong>
        <div className={`${c.textColor} text-sm mt-0.5`}>{children}</div>
      </div>
    </div>
  );
};

export default InfoCard;
